module.exports = __webpack_public_path__ + "img/album13_09.0ece8094.jpg";